import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  I18nService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteShippingFeeCountryDocument,
  DeleteShippingFeeCountryMutation,
} from "src/generated-gql/graphql";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

const deleteBulkActionShippingFeeZone: BulkAction = {
  location: "shipping-fee-zone-table",
  label: _("event.delete-selected-shipping-fee"),
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) => {
    return userPermissions.includes("DeleteShippingFee");
  },

  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    const translator = injector.get(I18nService);
    modalService
      .dialog({
        title: translator.translate("event.delete-selected-shipping-fee"),
        body: translator.translate("event.delete-shipping-fee-content", {
          selection: selection.length,
        }),
        buttons: [
          { type: "secondary", label: translator.translate("common.cancel") },
          {
            type: "primary",
            label: translator.translate("common.confirm-bulk-delete"),
            returnValue: selection,
          },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteShippingFeeCountryMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteShippingFeeCountryDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe((res) => {
            hostComponent.refresh();
            clearSelection();

            notificationService.success(
              _("common.notify-delete-success-with-count"),
              {
                count: res.length,
              }
            );
          });
        }
      });
  },
};

export { deleteBulkActionShippingFeeZone };
